import { Helmet } from "react-helmet";
import React, { Component } from "react";
import { Button, Table, Tabs, Tab, Form, Row, Col } from "react-bootstrap";
import axios from "axios";
import { apiHost } from "../../api/apiClient";
import ShowEntries from "../commoncomponents/ShowEntries";
import Search from "../commoncomponents/Search";
import { encodeQueryData } from "../../api/apiClient";
import Paginations from "../commoncomponents/pagination";
import ShowingResults from "../commoncomponents/showingResults";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import { utcToLocal } from "../../utils/dateConvert";
import "../../styles/groups/groups.scss";

class EditGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      groupID: "",
      groupList: [],
      assetDetails: [],
      assetIdList: [],
      assetIdBoolean: false,
      userIdBoolean: false,
      userIdList: [],
      menusequence: "",
      defaultGroup: "",
      customerID: "default",
      name: "",
      description: "",
      color: "#",
      icon: "",
      status: "",
      customerID_error: false,
      name_error: false,
      userPageCount: 0,
      assetsPageCount: 0,
      //states for showing entries and total entries in page on Assets
      totalEntryA: 0,
      entryStartA: "1",
      entryEndA: "10",
      totalFilterA: false,
      totalEntryFilterA: "",
      filterMessageA: false,
      //states for showing entries and total entries in page on Users
      totalEntryU: 0,
      entryStartU: "1",
      entryEndU: "10",
      totalFilterU: false,
      totalEntryFilterU: "",
      filterMessageU: false,
      //user table sort
      sortStringUser: "name",
      sortDirectionUser: "asc",
      //Asser table sort
      sortString: "name",
      sortDirection: "asc",
    };
    this.sortStringName = "name";
    this.sortDirection = "asc";
    this.sortStringNameUser = "name";
    this.sortDirectionUser = "asc";
    this.formSubmit = false;
    this.checkedAssets = [];
    this.assetsPageSize = "10";
    this.assetsSearchText = "";
    this.assetsPageKey = "1";
    this.usersPageSize = "10";
    this.usersSearchText = "";
    this.usersPageKey = "1";
    this.checkedUsers = "";
  }
  async componentDidMount() {
    console.log(this.props.match.params.id);
    let groupId = this.props.match.params.id;
    this.setState({ groupID: groupId });
    this.props.setLoadingPageAction(true);
    try {
      const groupList = await axios.get(
        `${apiHost}/api/Group/SelectGroup/${groupId}`,

        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      this.setState({ groupList: groupList.data });
      this.setState({
        customerID: groupList.data.customer_id,
        name: groupList.data.name,
        description: groupList.data.description,
        color: groupList.data.colour,
        icon: groupList.data.icon,
        status: groupList.data.status,
        menusequence: groupList.data.menuPriority,
        defaultGroup: groupList.data.menuDefault,
      });
      console.log("customer id", groupList.data);
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }

    let UrlAll = `${apiHost}/api/Group/AssetsByGroup/${groupId}?PageSize=10`;
    this.postAssets(UrlAll);

    let UrlUsers = `${apiHost}/api/Group/UsersByGroup/${groupId}?PageSize=10`;

    this.postUsers(UrlUsers);
    this.defaultGroupAutoCheck();
  }
  //Sort functionality of Assets table starts here

  handleSortString = (name) => {
    this.setState({
      sortString: name,
      sortDirection: "asc",
    });
    this.sortStringName = name;
    this.sortDirection = "asc";
    this.callback(name, this.sortDirection);
  };
  handleSortDirection = () => {
    if (this.state.sortDirection == "asc") {
      this.setState({
        sortDirection: "des",
      });
      this.sortDirection = "des";
    } else {
      this.setState({
        sortDirection: "asc",
      });
      this.sortDirection = "asc";
    }
    this.callback(this.sortStringName, this.sortDirection);
  };

  callback = (name, order) => {
    this.handleSort(name, order);
  };
  handleSort = (name, order) => {
    var checkBoxes = document.getElementsByClassName("tr-checkBox");
    for (var i in checkBoxes) {
      if (checkBoxes[i].checked) {
        checkBoxes[i].checked = false;
        var tr = document.getElementById(`tr-${checkBoxes[i].value}`);
        if (tr.bgColor == "#999999") {
          tr.bgColor = "#FFFFFF";
          tr.color = "#212529";
        } else {
          tr.bgColor = "#999999";
          tr.color = "#FFFFFF";
        }
      }
    }
    let groupId = this.props.match.params.id;
    this.sortString = name;
    this.sortDirection = order;
    console.log("name", this.sortString, "order", this.sortDirection);
    let query = encodeQueryData(this.setAssetsQueryObject());
    let urlAll = `${apiHost}/api/Group/AssetsByGroup/${groupId}?${query}`;

    this.postAssets(urlAll);
  };
  //Sort functionality of Assets table ends here
  //Sort functionality of user table starts here

  handleSortStringUser = (name) => {
    this.setState({
      sortStringUser: name,
      sortDirectionUser: "asc",
    });
    this.sortStringNameUser = name;
    this.sortDirectionUser = "asc";
    this.callbackUser(name, this.sortDirectionUser);
  };
  handleSortDirectionUser = () => {
    if (this.state.sortDirectionUser == "asc") {
      this.setState({
        sortDirectionUser: "des",
      });
      this.sortDirectionUser = "des";
    } else {
      this.setState({
        sortDirectionUser: "asc",
      });
      this.sortDirectionUser = "asc";
    }
    this.callbackUser(this.sortStringNameUser, this.sortDirectionUser);
  };

  callbackUser = (name, order) => {
    this.sortFunctionUser(name, order);
  };
  sortFunctionUser = (name, order) => {
    var checkBoxes = document.getElementsByClassName("tr-usercheckBox");
    for (var i in checkBoxes) {
      if (checkBoxes[i].checked) {
        checkBoxes[i].checked = false;
        var tr = document.getElementById(`truser-${checkBoxes[i].value}`);
        if (tr.bgColor == "#999999") {
          tr.bgColor = "#FFFFFF";
          tr.color = "#212529";
        } else {
          tr.bgColor = "#999999";
          tr.color = "#FFFFFF";
        }
      }
    }
    let groupId = this.props.match.params.id;
    this.sortStringUser = name;
    this.sortDirectionUser = order;
    console.log("name", this.sortStringUser, "order", this.sortDirectionUser);
    let query = encodeQueryData(this.setUsersQueryObject());

    console.log("query user noject", query);
    let urlAll = `${apiHost}/api/Group/UsersByGroup/${groupId}?${query}`;
    this.postUsers(urlAll);
  };
  //Sort functionality of user table ends here

  defaultGroupAutoCheck = () => {
    var checkBox = document.getElementById("defaultGroup");
    if (this.state.defaultGroup == 1) {
      checkBox.checked = true;
    }
  };
  handleDefaultGroup = () => {
    var checkBox = document.getElementById("defaultGroup");
    if (checkBox.checked) {
      this.setState({ defaultGroup: 1 });
    } else {
      this.setState({ defaultGroup: 0 });
    }
  };
  handleMenuSequence = (e) => {
    console.log(e.target.value);
    this.setState({
      menusequence: e.target.value,
    });
  };

  handleSearch = (inputSearch) => {
    //filtered by message on showing results
    if (inputSearch == "") {
      this.setState({ filterMessageA: false });
    } else {
      this.setState({ filterMessageA: true });
    }
    var checkBoxes = document.getElementsByClassName("tr-checkBox");
    for (var i in checkBoxes) {
      if (checkBoxes[i].checked) {
        checkBoxes[i].checked = false;
        var tr = document.getElementById(`tr-${checkBoxes[i].value}`);
        if (tr.bgColor == "#999999") {
          tr.bgColor = "#FFFFFF";
          tr.color = "#212529";
        } else {
          tr.bgColor = "#999999";
          tr.color = "#FFFFFF";
        }
      }
    }
    let groupId = this.props.match.params.id;
    this.assetsSearchText = inputSearch;
    let query = encodeQueryData(this.setAssetsQueryObject());
    let urlAll = `${apiHost}/api/Group/AssetsByGroup/${groupId}?${query}`;
    this.postAssets(urlAll);
  };

  handleShowEntries = (inputShowEntries) => {
    var checkBoxes = document.getElementsByClassName("tr-checkBox");
    for (var i in checkBoxes) {
      if (checkBoxes[i].checked) {
        checkBoxes[i].checked = false;
        var tr = document.getElementById(`tr-${checkBoxes[i].value}`);
        if (tr.bgColor == "#999999") {
          tr.bgColor = "#FFFFFF";
          tr.color = "#212529";
        } else {
          tr.bgColor = "#999999";
          tr.color = "#FFFFFF";
        }
      }
    }
    let groupId = this.props.match.params.id;
    console.log(inputShowEntries);
    this.assetsPageSize = inputShowEntries;
    let query = encodeQueryData(this.setAssetsQueryObject());
    let urlAll = `${apiHost}/api/Group/AssetsByGroup/${groupId}?${query}`;
    this.postAssets(urlAll);
  };

  setAssetsQueryObject = () => {
    let data = {};
    data.SearchString = this.assetsSearchText;
    data.PageSize = this.assetsPageSize;
    data.PageNumber = this.assetsPageKey;
    data.SortDirection = this.sortDirection;
    data.SortString = this.sortString;
    return data;
  };
  handleAssetsPagination = (page) => {
    var checkBoxes = document.getElementsByClassName("tr-checkBox");
    for (var i in checkBoxes) {
      if (checkBoxes[i].checked) {
        checkBoxes[i].checked = false;
        var tr = document.getElementById(`tr-${checkBoxes[i].value}`);
        if (tr.bgColor == "#999999") {
          tr.bgColor = "#FFFFFF";
          tr.style.color = "#212529";
        } else {
          tr.bgColor = "#999999";
          tr.style.color = "#FFFFFF";
        }
      }
    }
    let groupId = this.props.match.params.id;

    this.assetsPageKey = page;
    let query = encodeQueryData(this.setAssetsQueryObject());
    let urlAll = `${apiHost}/api/Group/AssetsByGroup/${groupId}?${query}`;

    this.postAssets(urlAll);
  };

  handleUserSearch = (inputSearch) => {
    //filtered by message on showing results
    if (inputSearch == "") {
      this.setState({ filterMessageU: false });
    } else {
      this.setState({ filterMessageU: true });
    }
    var checkBoxes = document.getElementsByClassName("tr-usercheckBox");
    for (var i in checkBoxes) {
      if (checkBoxes[i].checked) {
        checkBoxes[i].checked = false;
        var tr = document.getElementById(`truser-${checkBoxes[i].value}`);
        if (tr.bgColor == "#999999") {
          tr.bgColor = "#FFFFFF";
          tr.color = "#212529";
        } else {
          tr.bgColor = "#999999";
          tr.color = "#FFFFFF";
        }
      }
    }
    let groupId = this.props.match.params.id;
    this.usersSearchText = inputSearch;
    let query = encodeQueryData(this.setUsersQueryObject());
    let urlAll = `${apiHost}/api/Group/UsersByGroup/${groupId}?${query}`;
    this.postUsers(urlAll);
  };

  handleUserShowEntries = (inputShowEntries) => {
    var checkBoxes = document.getElementsByClassName("tr-usercheckBox");
    for (var i in checkBoxes) {
      if (checkBoxes[i].checked) {
        checkBoxes[i].checked = false;
        var tr = document.getElementById(`truser-${checkBoxes[i].value}`);
        if (tr.bgColor == "#999999") {
          tr.bgColor = "#FFFFFF";
          tr.color = "#212529";
        } else {
          tr.bgColor = "#999999";
          tr.color = "#FFFFFF";
        }
      }
    }
    let groupId = this.props.match.params.id;
    console.log(inputShowEntries);
    this.usersPageSize = inputShowEntries;
    let query = encodeQueryData(this.setUsersQueryObject());
    let urlAll = `${apiHost}/api/Group/UsersByGroup/${groupId}?${query}`;
    this.postUsers(urlAll);
  };

  setUsersQueryObject = () => {
    let data = {};
    data.SearchString = this.usersSearchText;
    data.PageSize = this.usersPageSize;
    data.PageNumber = this.usersPageKey;
    data.SortDirection = this.sortDirectionUser;
    data.SortString = this.sortStringUser;
    return data;
  };

  handleUsersPagination = (page) => {
    var checkBoxes = document.getElementsByClassName("tr-usercheckBox");
    for (var i in checkBoxes) {
      if (checkBoxes[i].checked) {
        checkBoxes[i].checked = false;
        var tr = document.getElementById(`truser-${checkBoxes[i].value}`);
        if (tr.bgColor == "#999999") {
          tr.bgColor = "#FFFFFF";
          tr.color = "#212529";
        } else {
          tr.bgColor = "#999999";
          tr.color = "#FFFFFF";
        }
      }
    }
    let groupId = this.props.match.params.id;

    this.usersPageKey = page;
    let query = encodeQueryData(this.setUsersQueryObject());
    let urlAll = `${apiHost}/api/Group/UsersByGroup/${groupId}?${query}`;

    this.postUsers(urlAll);
  };

  handleShowAssetsResults = (response) => {
    // function for showing entries and total entries in page

    this.setState({
      totalEntryA: JSON.parse(response.headers.pagination).totalItems,
    });
    if (!this.state.totalFilterA) {
      this.setState({
        totalEntryFilterA: JSON.parse(response.headers.pagination).totalItems,
        totalFilterA: true,
      });
    }
    this.setState({
      entryStartA:
        (parseInt(this.assetsPageKey) - 1) * parseInt(this.assetsPageSize) + 1,
    });
    if (
      JSON.parse(response.headers.pagination).totalItems <
      parseInt(this.state.entryEndA)
    ) {
      this.setState({
        entryEndA: JSON.parse(response.headers.pagination).totalItems,
      });
    } else {
      let value =
        parseInt(JSON.parse(response.headers.pagination).currentPage) *
        parseInt(this.assetsPageSize);
      this.setState({ entryEndA: value });
    }
    if (
      this.state.entryEndA >
      parseInt(JSON.parse(response.headers.pagination).totalItems)
    ) {
      this.setState({
        entryEndA: JSON.parse(response.headers.pagination).totalItems,
      });
    }
    if (this.state.assetDetails == "") {
      this.setState({ entryStartA: "0", entryEndA: "0", totalEntryA: "0" });
    }
  };

  handleShowUsersResults = (response) => {
    // function for showing entries and total entries in page

    this.setState({
      totalEntryU: JSON.parse(response.headers.pagination).totalItems,
    });
    if (!this.state.totalFilterU) {
      this.setState({
        totalEntryFilterU: JSON.parse(response.headers.pagination).totalItems,
        totalFilterU: true,
      });
    }
    this.setState({
      entryStartU:
        (parseInt(this.usersPageKey) - 1) * parseInt(this.usersPageSize) + 1,
    });
    if (
      JSON.parse(response.headers.pagination).totalItems <
      parseInt(this.state.entryEndU)
    ) {
      this.setState({
        entryEndU: JSON.parse(response.headers.pagination).totalItems,
      });
    } else {
      let value =
        parseInt(JSON.parse(response.headers.pagination).currentPage) *
        parseInt(this.usersPageSize);
      this.setState({ entryEndU: value });
    }
    if (
      this.state.entryEndU >
      parseInt(JSON.parse(response.headers.pagination).totalItems)
    ) {
      this.setState({
        entryEndU: JSON.parse(response.headers.pagination).totalItems,
      });
    }
    if (this.state.userIdList == "") {
      this.setState({ entryStartU: "0", entryEndU: "0", totalEntryU: "0" });
    }
  };
  postAssets = async (url) => {
    this.props.setLoadingPageAction(true);
    try {
      let assetDetails = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      console.log("assetDetails", assetDetails);
      this.setState({
        assetDetails: assetDetails.data.paggedlist,
        assetsPageCount: JSON.parse(assetDetails.headers.pagination).totalPages,
      });
      if (!this.state.assetIdBoolean) {
        this.setState({ assetIdBoolean: true });

        this.checkedAssets = assetDetails.data.includedelements;
      }
      this.handleShowAssetsResults(assetDetails);
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
    var checkBoxes = document.getElementsByClassName("tr-checkBox");

    for (var i in checkBoxes) {
      for (var j in this.checkedAssets) {
        if (checkBoxes[i].value === this.checkedAssets[j]) {
          checkBoxes[i].checked = true;
          var tr = document.getElementById(`tr-${checkBoxes[i].value}`);
          if (tr.bgColor == "#999999") {
            tr.bgColor = "#FFFFFF";
            tr.color = "#212529";
          } else {
            tr.bgColor = "#999999";
            tr.color = "#FFFFFF";
          }
        }
      }
    }
  };

  postUsers = async (url) => {
    this.props.setLoadingPageAction(true);
    try {
      let userIdList = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      console.log("userIdList", userIdList);
      this.setState({
        userIdList: userIdList.data.paggedlist,
        userPageCount: JSON.parse(userIdList.headers.pagination).totalPages,
      });
      if (!this.state.userIdBoolean) {
        this.setState({ userIdBoolean: true });

        this.checkedUsers = userIdList.data.includedelements;
      }
      this.handleShowUsersResults(userIdList);
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
    var checkBoxesUser = document.getElementsByClassName("tr-usercheckBox");

    console.log("newhchecks", checkBoxesUser);
    console.log("checked users", this.checkedUsers);

    for (var i in checkBoxesUser) {
      for (var j in this.checkedUsers) {
        if (checkBoxesUser[i].value === this.checkedUsers[j]) {
          checkBoxesUser[i].checked = true;
          var tr = document.getElementById(
            `truser-${checkBoxesUser[i].value}`
          );
          if (tr.bgColor == "#999999") {
            tr.bgColor = "#FFFFFF";
            tr.color = "#212529";
          } else {
            tr.bgColor = "#999999";
            tr.color = "#FFFFFF";
          }
        }
      }
    }
  };

  handleNameChange(e) {
    console.log("e.target.value", e.target.value);
    if (e.target.value == "") {
      this.setState({ name_error: true });
    } else {
      this.setState({ name_error: false });
    }
    this.setState({ name: e.target.value });
  }
  handleColorChange = (e) => {
    this.setState({ color: e.target.value });
  };
  handleDescriptionChange(e) {
    this.setState({ description: e.target.value });
  }
  handleConfirmIconChange(e) {
    this.setState({ icon: e.target.value });
  }
  handleStatusChange(e) {
    this.setState({ status: e.target.value });
    console.log(e.target.value);
  }

  async handleSubmit() {
    this.formSubmit = true;
    if (this.state.customerID == "default") {
      this.setState({ customerID_error: true });
      this.formSubmit = false;
    }

    if (this.state.name == "") {
      this.setState({ name_error: true });
      this.formSubmit = false;
    }

    if (this.formSubmit) {
      this.props.setLoadingPageAction(true);

      try {
        const response = await axios.post(
          `${apiHost}/api/Group/UpdateGroup`,
          {
            Id: this.state.groupList.id,
            Name: this.state.name,
            CustomerId: this.state.groupList.customerId,
            Description: this.state.description,
            Colour: this.state.color,
            Icon: this.state.icon,
            Status: this.state.status,
            AssetIds: this.checkedAssets,
            UserIds: this.checkedUsers,
            dbUpdated: this.state.groupList.dbUpdated,
            dbCreated: this.state.groupList.dbCreated,
            MenuDefault: this.state.defaultGroup,
            MenuPriority: this.state.menusequence,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );
        //  this.props.history.push("/groups");
        this.props.history.goBack();
        console.log("customer id", response.data);
        this.props.setLoadingPageAction(false);
      } catch (e) {
        if (e.response.status == "401") {
          this.props.history.push("/login");
        } else {
          this.props.setErrorMessageAction(`${e}`);
        }
        this.props.setLoadingPageAction(false);

        console.log(`😱 Axios request failed: ${e}`);
      }
    }
  }

  handleCheck = (assets) => {
    var CheckBox = document.getElementById(assets);

    if (CheckBox.checked == true) {
      CheckBox.checked = false;
    } else {
      CheckBox.checked = true;
    }

    if (CheckBox.checked == true) {
      this.checkedAssets.push(assets);
    } else {
      const index = this.checkedAssets.indexOf(assets);

      this.checkedAssets.splice(index, 1);
    }
    console.log("checked assets array", this.checkedAssets);
  };
  color = (row) => {
    var tr = document.getElementById(`tr-${row}`);
    if (tr.bgColor == "#999999") {
      tr.bgColor = "#FFFFFF";
      tr.color = "#212529";
    } else {
      tr.bgColor = "#999999";
      tr.color = "#FFFFFF";
    }
  };

  handleUserCheck = (assets) => {
    var CheckBox = document.getElementById(assets);

    if (CheckBox.checked == true) {
      CheckBox.checked = false;
    } else {
      CheckBox.checked = true;
    }

    if (CheckBox.checked == true) {
      this.checkedUsers.push(assets);
    } else {
      const index = this.checkedUsers.indexOf(assets);

      this.checkedUsers.splice(index, 1);
    }
    console.log("checked assets array", this.checkedUsers);
  };
  colorUser = (row) => {
    var tr = document.getElementById(`truser-${row}`);
    if (tr.bgColor == "#999999") {
      tr.bgColor = "#FFFFFF";
      tr.color = "#212529";
    } else {
      tr.bgColor = "#999999";
      tr.color = "#FFFFFF";
    }
  };

  render() {
    const { groupList } = this.state;
    const arr = [10, 25, 50, 100];
    console.log("asset details,...", this.state.assetDetails);
    return (
      <div>
        <Layout>
          <Helmet>
            <title>Edit Group </title>
          </Helmet>

          <div className="contentBodyEditGroup">
            <div className="contentWrapper">
              <h2>Edit Group</h2>
              <h6>edit</h6>
              <hr></hr>
              <Tabs>
                <Tab eventKey="details" title="Details">
                  <div className="groupEditDetail">
                    <Form>
                      <Form.Group
                        as={Row}
                        controlId="exampleForm.HorizontalControlSelect1"
                      >
                        <Form.Label column sm={2}>
                          <span className="inline-input"> Customer</span>
                        </Form.Label>
                        <Col sm={10}>
                          <h6 className="customername">
                            {" "}
                            {groupList.customerName}
                          </h6>
                          <p
                            style={
                              this.state.customerID_error
                                ? { color: "#a94442", fontSize: "14px" }
                                : { display: "none" }
                            }
                          >
                            The Customer field is required.
                          </p>
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} controlId="formHorizontalEmail">
                        <Form.Label column sm={2}>
                          <span className="inline-input">Name</span>
                        </Form.Label>
                        <Col sm={3}>
                          <Form.Control
                            type="text"
                            value={this.state.name}
                            onChange={this.handleNameChange.bind(this)}
                          />
                          <p
                            style={
                              this.state.name_error
                                ? { color: "#a94442", fontSize: "14px" }
                                : { display: "none" }
                            }
                          >
                            The Name field is required.
                          </p>
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} controlId="formHorizontalEmail">
                        <Form.Label column sm={2}>
                          <span className="inline-input"> Description</span>
                        </Form.Label>
                        <Col sm={10}>
                          <Form.Control
                            as="textarea"
                            value={this.state.description}
                            onChange={this.handleDescriptionChange.bind(this)}
                            rows="3"
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="formHorizontalEmail">
                        <Form.Label column sm={2}>
                          <span className="inline-input"> Colour</span>
                        </Form.Label>
                        <Col sm={3}>
                          <Form.Control
                            type="text"
                            value={this.state.color}
                            onChange={this.handleColorChange.bind(this)}
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="formHorizontalEmail">
                        <Form.Label column sm={2}>
                          <span className="inline-input"> Icon</span>
                        </Form.Label>
                        <Col sm={3}>
                          <Form.Control
                            type="text"
                            value={this.state.icon}
                            onChange={this.handleConfirmIconChange.bind(this)}
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="formHorizontalEmail">
                        <Form.Label column sm={2}>
                          <span className="inline-input"> Default Group</span>
                        </Form.Label>
                        <Col sm={3}>
                          <input
                            type="checkbox"
                            id="defaultGroup"
                            style={{ position: "relative", top: "8px" }}
                            onChange={this.handleDefaultGroup}
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        controlId="exampleForm.ControlInput1"
                      >
                        <Form.Label column sm={2}>
                          {" "}
                          <span className="inline-input"> Menu Sequence</span>
                        </Form.Label>
                        <Col sm={10}>
                          <Form.Control
                            type="number"
                            value={this.state.menusequence}
                            onChange={this.handleMenuSequence}
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="formHorizontalEmail">
                        <Form.Label column sm={2}>
                          <span className="inline-input"> Status</span>
                        </Form.Label>
                        <Col sm={10}>
                          <Form.Control
                            as="select"
                            value={this.state.status}
                            onChange={this.handleStatusChange.bind(this)}
                          >
                            <option value="Active">Active</option>
                            <option value="Disable">Disabled</option>
                          </Form.Control>
                        </Col>
                      </Form.Group>
                      {/* <Form.Group>
                        <Form.Label column sm={2}>
                          {" "}
                          <span className="inline-input"> External ID</span>
                        </Form.Label>
                        <Form.Label column sm={3}>
                          {groupList.externalId}
                        </Form.Label>
                      </Form.Group> */}
                      <Form.Group>
                        <Form.Label column sm={2}>
                          {" "}
                          <span className="inline-input"> Created</span>
                        </Form.Label>
                        <Form.Label column sm={3}>
                          <span style={{ position: "relative", top: "-12px" }}>
                            {" "}
                            {utcToLocal(groupList.dbCreated)}{" "}
                          </span>
                        </Form.Label>
                      </Form.Group>
                      <Form.Group
                        style={{ position: "relative", top: "-22px" }}
                      >
                        <Form.Label column sm={2}>
                          {" "}
                          <span className="inline-input"> Updated</span>
                        </Form.Label>
                        <Form.Label column sm={3}>
                          <span style={{ position: "relative", top: "-12px" }}>
                            {" "}
                            {utcToLocal(groupList.dbUpdated)}{" "}
                          </span>
                        </Form.Label>
                      </Form.Group>
                    </Form>
                  </div>
                </Tab>
                <Tab eventKey="assets" title="Assets">
                  <div className="inline">
                    {" "}
                    <ShowEntries
                      data={arr}
                      showEntriesCallback={this.handleShowEntries}
                    />
                    <Search searchCallback={this.handleSearch}></Search>
                  </div>
                  <Table responsive>
                    <thead>
                      <tr>
                        <th></th>
                        <th>
                          Name{" "}
                          {this.state.sortString == "name" ? (
                            <i
                              onClick={this.handleSortDirection}
                              className={`fa ${this.state.sortDirection == "asc"
                                ? "fa-sort-amount-asc"
                                : "fa-sort-amount-desc"
                                }`}
                            />
                          ) : (
                            <i
                              className="fa fa-exchange"
                              onClick={() => {
                                this.handleSortString("name");
                              }}
                            />
                          )}
                        </th>
                        <th>
                          Tag1{" "}
                          {this.state.sortString == "tag1" ? (
                            <i
                              onClick={this.handleSortDirection}
                              className={`fa ${this.state.sortDirection == "asc"
                                ? "fa-sort-amount-asc"
                                : "fa-sort-amount-desc"
                                }`}
                            />
                          ) : (
                            <i
                              className="fa fa-exchange"
                              onClick={() => {
                                this.handleSortString("tag1");
                              }}
                            />
                          )}
                        </th>
                        <th>
                          Tag2{" "}
                          {this.state.sortString == "tag2" ? (
                            <i
                              onClick={this.handleSortDirection}
                              className={`fa ${this.state.sortDirection == "asc"
                                ? "fa-sort-amount-asc"
                                : "fa-sort-amount-desc"
                                }`}
                            />
                          ) : (
                            <i
                              className="fa fa-exchange"
                              onClick={() => {
                                this.handleSortString("tag2");
                              }}
                            />
                          )}
                        </th>
                        <th>Description </th>
                        <th>
                          Status{" "}
                          {this.state.sortString == "status" ? (
                            <i
                              onClick={this.handleSortDirection}
                              className={`fa ${this.state.sortDirection == "asc"
                                ? "fa-sort-amount-asc"
                                : "fa-sort-amount-desc"
                                }`}
                            />
                          ) : (
                            <i
                              className="fa fa-exchange"
                              onClick={() => {
                                this.handleSortString("status");
                              }}
                            />
                          )}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.assetDetails.map((assets, index) => {
                        return (
                          <tr
                            value={assets.id}
                            id={`tr-${assets.id}`}
                            bgcolor="#FFFFFF"
                            onClick={(e) => {
                              this.color(assets.id);
                              this.handleCheck(assets.id);
                            }}
                          >
                            <td>
                              <input
                                type="checkbox"
                                id={assets.id}
                                value={assets.id}
                                className="tr-checkBox"
                                style={{ pointerEvents: "none" }}
                              />
                            </td>
                            <td>{assets.name}</td>
                            <td>{assets.tag1}</td>
                            <td>{assets.tag2}</td>
                            <td>{assets.description}</td>

                            <td>{assets.status}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                  <div className="paginationDetails">
                    <ShowingResults
                      currentEntryStart={this.state.entryStartA}
                      currentEntryEnd={this.state.entryEndA}
                      totalEntries={this.state.totalEntryA}
                      totalFilterEntries={this.state.totalEntryFilterA}
                      filterMessage={this.state.filterMessageA}
                    />
                    <Paginations
                      onPagination={this.handleAssetsPagination}
                      pageCount={this.state.assetsPageCount}
                      pageRange={5}
                    ></Paginations>
                  </div>
                </Tab>
                <Tab eventKey="members" title="Members">
                  <div className="inline">
                    {" "}
                    <ShowEntries
                      data={arr}
                      showEntriesCallback={this.handleUserShowEntries}
                    />
                    <Search searchCallback={this.handleUserSearch}></Search>
                  </div>
                  <Table responsive>
                    <thead>
                      <tr>
                        <th></th>
                        <th>
                          Name{" "}
                          {this.state.sortStringUser == "name" ? (
                            <i
                              onClick={this.handleSortDirectionUser}
                              className={`fa ${this.state.sortDirectionUser == "asc"
                                ? "fa-sort-amount-asc"
                                : "fa-sort-amount-desc"
                                }`}
                            />
                          ) : (
                            <i
                              className="fa fa-exchange"
                              onClick={() => {
                                this.handleSortStringUser("name");
                              }}
                            />
                          )}{" "}
                        </th>
                        <th>
                          Email{" "}
                          {this.state.sortStringUser == "email" ? (
                            <i
                              onClick={this.handleSortDirectionUser}
                              className={`fa ${this.state.sortDirectionUser == "asc"
                                ? "fa-sort-amount-asc"
                                : "fa-sort-amount-desc"
                                }`}
                            />
                          ) : (
                            <i
                              className="fa fa-exchange"
                              onClick={() => {
                                this.handleSortStringUser("email");
                              }}
                            />
                          )}{" "}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.userIdList.map((users, index) => {
                        return (
                          <tr
                            value={users.id}
                            id={`truser-${users.id}`}
                            bgcolor="#FFFFFF"
                            onClick={(e) => {
                              this.colorUser(users.id);
                              this.handleUserCheck(users.id);
                            }}
                          >
                            <td>
                              <input
                                type="checkbox"
                                id={users.id}
                                value={users.id}
                                className="tr-usercheckBox"
                                style={{ pointerEvents: "none" }}
                              />
                            </td>
                            <td>{users.userName}</td>
                            <td>{users.email}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                  <div className="paginationDetails">
                    <ShowingResults
                      currentEntryStart={this.state.entryStartU}
                      currentEntryEnd={this.state.entryEndU}
                      totalEntries={this.state.totalEntryU}
                      totalFilterEntries={this.state.totalEntryFilterU}
                      filterMessage={this.state.filterMessageU}
                    />
                    <Paginations
                      onPagination={this.handleUsersPagination}
                      pageCount={this.state.userPageCount}
                      pageRange={5}
                    ></Paginations>
                  </div>
                </Tab>
              </Tabs>
              <div className="footer-menu">
                <Button
                  size="sm"
                  variant="outline-secondary"
                  onClick={() => {
                    //this.props.history.push("/groups");
                    this.props.history.goBack();
                  }}
                >
                  Back to List
                </Button>
                &nbsp;
                <Button
                  size="sm"
                  variant="primary"
                  onClick={this.handleSubmit.bind(this)}
                >
                  Save
                </Button>
              </div>
            </div>
          </div>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditGroup);
